import { Icon } from '../../../../atoms/Icon/Icon';
import { GoalTypeEnum } from '../../../../../common/types';
import { RETIREMENT_CATEGORY_GOALS, WEALTH_CATEGORY_GOALS } from '../../../../../common/constants';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

type Props = {
    type: GoalTypeEnum;
};

export const Goal = ({ type }: Props) => {
    const { t } = useTranslation();
    const { backgroundColor, color, title, icon } = getGoal(type) || {};
    return (
        <Container>
            <IconContainer backgroundColor={backgroundColor} color={color}>
                <Icon id={icon!} fill="currentColor" />
            </IconContainer>
            <Text>{t(title?.toUpperCase() ?? '')}</Text>
        </Container>
    );
};

const Container = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center'
}));

const IconContainer = styled('div')<{ backgroundColor?: string; color?: string }>(({ backgroundColor, color }) => ({
    display: 'flex',
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    backgroundColor,
    color,
    marginRight: '8px',

    '> svg': {
        width: '16px',
        height: '16px'
    }
}));

const Text = styled('span')(({ theme }: any) => ({
    ...theme.typography.body.overline,
    fontWeight: 500,
    fontSize: '16px',
    color: theme.palette.semantic.text.default
}));

const getGoal = (type: GoalTypeEnum) => {
    const goalTypes = [...RETIREMENT_CATEGORY_GOALS, ...WEALTH_CATEGORY_GOALS];

    return goalTypes.find((goalType) => goalType.type === type);
};
